import { createStyles, makeStyles, Stepper as MuiStepper, Tooltip } from '@material-ui/core';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import React from 'react';

export type StepStatus = 'unvisited' | 'incomplete' | 'complete';

export interface StepDef {
  title: string;
  content: JSX.Element;
  status?: StepStatus;
  invalidFields?: string[];
}

export interface StepperProps {
  steps: StepDef[];
  currentStep: number;
  onChange: (step: number) => void;
  disabled?: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    stepper: {
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid #e0e0e0',
      backgroundColor: '#ffffff',
    },
    step: {
      cursor: 'pointer',
    },
    incompleteIcon: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F57C00',
      color: 'white',
    },
  }),
);

const IncompleteStepIcon: React.FC<{ title?: string }> = ({ title }) => {
  const classes = useStyles();

  return (
    <Tooltip title={title ?? ''}>
      <div className={classes.incompleteIcon}>
        <ReportProblemOutlinedIcon style={{ fontSize: 16, marginTop: -2 }} />
      </div>
    </Tooltip>
  );
};

export default function Stepper({ steps, currentStep, onChange, disabled }: Readonly<StepperProps>) {
  const classes = useStyles();

  return (
    <MuiStepper nonLinear connector={<></>} activeStep={currentStep} className={classes.stepper}>
      {steps.map((step: StepDef, index: number) => {
        const isComplete = step.status === 'complete';
        const isIncomplete = step.status === 'incomplete';

        return (
          <Step
            className={classes.step}
            key={step.title}
            onClick={() => !disabled && onChange(index)}
            disabled={disabled}
            completed={isComplete}
          >
            <StepLabel
              {...(isIncomplete && {
                StepIconComponent: IncompleteStepIcon,
                StepIconProps: { title: step.invalidFields?.join(', ') },
              })}
            >
              {step.title}
            </StepLabel>
          </Step>
        );
      })}
    </MuiStepper>
  );
}
